import React, { Component } from "react";
import { translate } from "react-translate"
import { Icon } from "semantic-ui-react"
// CSS styling
import './SideRowOptions.css'

class SideRowOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popupOpen : false
        }
    }

    togglePopupOpen = () => {
        this.setState({popupOpen: !this.state.popupOpen});
    }

    closePopup = () => {
        this.setState({popupOpen: false});
    }

    render() {
        var {row, onInsertLineAbove, onInsertPageJumpAbove, onDelete } = this.props;
        // Fallbacks for not defined functions
        if(!onInsertLineAbove)
            onInsertLineAbove = function(){console.log("onInsertLineAbove(row) not implemented")}
        if(!onInsertPageJumpAbove)
            onInsertPageJumpAbove = function(){console.log("onInsertPageJumpAbove(row) not implemented")}
        if(!onDelete)
            onDelete = function(){console.log("onDelete(row) not implemented")}
        
        return(
            <div className="rightOptionsWrapper">
                <div 
                    className="optionsCmd"
                    onClick={() => this.togglePopupOpen()}
                    onBlur={() => this.closePopup()}
                >
                    <Icon name="bars" centered="true"/>
                </div>
                {
                    this.state.popupOpen ? (
                        <div id="optionsPopup"
                            onBlur={()=> console.log("On blur")}
                            onBlurCapture={()=> console.log("On blur cap")}
                        >
                            <div className="optionRow" onClick={(e) => {e.stopPropagation(); onInsertLineAbove(row)}}>
                                <Icon name="level up alternate"/>
                                Insérer une ligne au dessus
                            </div>
                            <div className="optionRow" onClick={(e) => {e.stopPropagation(); onInsertPageJumpAbove(row)}}>
                                <Icon name="angle double up"/>    
                                Insérer un saut de page au dessus
                            </div>
                            <div className="optionRow" onClick={(e) => {e.stopPropagation(); onDelete(row)}}>
                                <Icon name="trash"/>
                                Retirer cette ligne
                            </div>
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

export default translate("ProDevisRowSidePanel")(SideRowOptions)


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/SideRowOptions.jsx